// 基础信息API
import axios from './request'

/**
 * 获取部门tree
 * @author fry
 * @returns
 */
 export function getDepartmentTree() {
    return axios({
        url: '/all-elements/api/v1/base/getDepartTree',
        method: 'post',
        params:{

        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}


/**
 * 获取部门tree echarts
 * @author fry
 * @returns
 */
 export function getDepartTreeE() {
    return axios({
        url: '/all-elements/api/v1/base/getDepartTreeE',
        method: 'post',
        params:{

        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 获取部门
 * @author fry
 * @returns
 */
 export function getDepartment(query) {
    return axios({
        url: '/all-elements/api/v1/base/getDepart',
        method: 'post',
        params:query,
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 新增部门
 * @author fry
 * @returns
 */
 export function addDepartment(data) {
    return axios({
        url: '/all-elements/api/v1/base/insertDepart',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 修改部门
 * @author fry
 * @returns
 */
 export function updateDepartment(data) {
    return axios({
        url: '/all-elements/api/v1/base/updateDepart',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 删除部门
 * @author fry
 * @returns
 */
 export function delDepartment({ id }) {
    return axios({
        url: '/all-elements/api/v1/base/delDepart',
        method: 'post',
        params:{
            departId:id
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 获取所有岗位
 * @author fry
 * @returns
 */
 export function getPost({pageNum,pageSize,postName,departId}) {
    return axios({
        url: '/all-elements/api/v1/base/getPost',
        method: 'post',
        params:{
            pageNum,pageSize,postName,departId
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 获取部门未分配的岗位
 * @author fry
 * @returns
 */
 export function getDisPost({departId,postName}) {
    return axios({
        url: '/all-elements/api/v1/base/getDisPost',
        method: 'post',
        params:{
            departId,postName
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 新增岗位
 * @author fry
 * @returns
 */
 export function insertPost(data) {
    return axios({
        url: '/all-elements/api/v1/base/insertPost',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 修改岗位
 * @author fry
 * @returns
 */
 export function UPdatePost(data) {
    return axios({
        url: '/all-elements/api/v1/base/updatePost',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 删除岗位
 * @author fry
 * @returns
 */
 export function delPost({id}) {
    return axios({
        url: '/all-elements/api/v1/base/delPost',
        method: 'post',
        params:{
            id
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 批量删除岗位
 * @author fry
 * @returns
 */
 export function delPosts({ids}) {
    return axios({
        url: '/all-elements/api/v1/base/delPosts',
        method: 'post',
        params:{
            ids
        },
        // data:Qs.stringify({ids:ids}),
        headers: {
            // 'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token'),
        },
    })
}

/**
 * 根据部门ID获取部门已分配岗位
 * @author fry
 * @returns
 */
 export function getPostById({id}) {
    return axios({
        url: '/all-elements/api/v1/base/getDepartPost',
        method: 'post',
        params:{
            departId:id
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 分配岗位
 * @author fry
 * @returns
 */
 export function disPost({departId,postIds}) {
     console.log(postIds);
    return axios({
        url: '/all-elements/api/v1/base/disPost',
        method: 'post',
        params:{
            departId,
            postIds
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 移除岗位
 * @author fry
 * @returns
 */
 export function removePost({departId,postId}) {
   return axios({
       url: '/all-elements/api/v1/base/removePost',
       method: 'post',
       params:{
           departId,
           postId
       },
       headers: {
           // 'Content-Type': 'application/x-www-form-urlencoded',
             'token':sessionStorage.getItem('token')
       },
   })
}

/**
 * 获取人员基本信息
 * @author fry
 * @returns
 */
 export function getStaffAll({departId,name,phone,sex,jobSitu,pageNum,pageSize,postId}) {
   return axios({
       url: '/all-elements/api/v1/base/getStaffAll',
       method: 'post',
       params:{
           departId,
           name,
           phone,
           sex,
           jobSitu,pageNum,pageSize,postId
       },
       headers: {
           // 'Content-Type': 'application/x-www-form-urlencoded',
             'token':sessionStorage.getItem('token')
       },
   })
}
/**
 * 获取人员基本信息
 * @author fry
 * @returns
 */
 export function getAllStaff() {
   return axios({
       url: '/all-elements/api/v1/base/getAllStaff',
       method: 'post',
       headers: {
           'Content-Type': 'application/json',
             'token':sessionStorage.getItem('token')
       },
   })
}

/**
 * 新增人员基本信息
 * @author fry
 * @returns
 */
 export function insertStaff(data) {
    return axios({
        url: '/all-elements/api/v1/base/insertStaff',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 修改人员基本信息
 * @author fry
 * @returns
 */
  export function updateStaff(data) {
    return axios({
        url: '/all-elements/api/v1/base/updateStaff',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 删除人员
 * @author fry
 * @returns
 */
  export function delStaff({id}) {
    return axios({
        url: '/all-elements/api/v1/base/delStaff',
        method: 'post',
        params:{
            id
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 人员照片预览
 * @author fry
 * @returns
 */
  export function getFileUrl({url}) {
    return axios({
        url: '/all-elements/api/v1/other/getFileUrl',
        method: 'post',
        params:{
            url
        },

    })
 }

 /**
 * 巡检点二维码
 * @author fry
 * @returns
 */
  export function getQrcode({url}) {
    return axios({
        url: '/all-elements/api/v1/other/getQrcode',
        method: 'post',
        params:{
            url
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 获取证书类型
 * @author fry
 * @returns
 */
  export function getCertType() {
    return axios({
        url: '/all-elements/api/v1/base/getCertType',
        method: 'post',
        params:{

        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
}

/**
 * 新增证书类型
 * @author fry
 * @returns
 */
 export function insertCertType(data) {
    return axios({
        url: '/all-elements/api/v1/base/insertCertType',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 修改证书类型
 * @author fry
 * @returns
 */
  export function updateCertType(data) {
    return axios({
        url: '/all-elements/api/v1/base/updateCertType',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 删除证书类型
 * @author fry
 * @returns
 */
  export function delCertType({id}) {
    return axios({
        url: '/all-elements/api/v1/base/delCertType',
        method: 'post',
        params:{
            id
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 获取在用证书，或根据姓名查寻证书
 * @author fry
 * @returns
 */
  export function getCertStaff({name}) {
    return axios({
        url: '/all-elements/api/v1/base/getCertStaff',
        method: 'post',
        params:{
            name
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }
 /**
 * 获取历史证书
 * @author fry
 * @returns
 */
  export function getHistoryCert() {
    return axios({
        url: '/all-elements/api/v1/base/getHistoryCert',
        method: 'post',
        params:{

        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }
 /**
 * 获取缺失证书
 * @author fry
 * @returns
 */
  export function getLackCert() {
    return axios({
        url: '/all-elements/api/v1/base/getLackCert',
        method: 'post',
        params:{

        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 获取超期证书
 * @author fry
 * @returns
 */
  export function getOverdueCert() {
    return axios({
        url: '/all-elements/api/v1/base/getOverdueCert',
        method: 'post',
        params:{

        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 获取离职人员证书
 * @author fry
 * @returns
 */
  export function getQuitCert() {
    return axios({
        url: '/all-elements/api/v1/base/getQuitCert',
        method: 'post',
        params:{

        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 获取分配过的岗位证书
 * @author fry
 * @returns
 */
  export function getCertPost({postId,flg}) {
    return axios({
        url: '/all-elements/api/v1/base/getCertPost',
        method: 'post',
        params:{
            postId,
            flg
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 分配岗位证书
 * @author fry
 * @returns
 */
  export function disPostCertType({postId,certTypeIds}) {
    return axios({
        url: '/all-elements/api/v1/base/disPostCertType',
        method: 'post',
        params:{
            postId,
            certTypeIds
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 移除岗位证书
 * @author fry
 * @returns
 */
  export function removePostCert({postId,certId}) {
    return axios({
        url: '/all-elements/api/v1/base/removePostCert',
        method: 'post',
        params:{
            postId,
            certId
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

  /**
 * 根据人员id获取证书
 * @author fry
 * @returns
 */
   export function getStaffCert({staffid}) {
    return axios({
        url: '/all-elements/api/v1/base/getStaffCert',
        method: 'post',
        params:{
            staffid
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

 /**
 * 新增人员证书
 * @author fry
 * @returns
 */
  export function insertCertStaff(data) {
    return axios({
        url: '/all-elements/api/v1/base/insertCertStaff',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
 }

  /**
 * 修改人员证书
 * @author fry
 * @returns
 */
   export function updateCertStaff(data) {
    return axios({
        url: '/all-elements/api/v1/base/updateCertStaff',
        method: 'post',
        data:data,
        headers: {
            'Content-Type': 'application/json',
              'token':sessionStorage.getItem('token')
        },
    })
 }

  /**
 * 根据证书id删除证书
 * @author fry
 * @returns
 */
   export function delCertStaff({id}) {
    return axios({
        url: '/all-elements/api/v1/base/delCertStaff',
        method: 'post',
        params:{
            id
        },
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
              'token':sessionStorage.getItem('token')
        },
    })
 }

/**
 * 获取当前用户数据
 */
export function getInfo() {
    return axios({
        url: '/all-elements/api/v1/base/getInfo',
        method: 'post'
    })
}
